var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tableShow"},[_c('Table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
      opId:"3179",
      name:"外部系统对接设置明细详情",
      parentId:"DATA_ID",
      parentName:"外部系统对接设置明细",
      parentPath:"/system/interfaceSetupSon",
      parentQuery:{
      },
      addForm:{
      },
      dataClass:21,
      col:[]
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }